import { getPath } from '@/router/common'

const baseUrl = {
  title: '财务对账',
  path: 'FinancialReconciliation'
}

export default [
  {
    path: getPath('CustomerReconciliation_F9', baseUrl),
    name: 'CustomerReconciliation_F9',
    component: () =>
      import(
        /* webpackChunkName: "CustomerReconciliation_F9" */ '@/views/financialReconciliation/customerReconciliation_F9/index.vue'
      ),
    meta: {
      title: '客户对账'
    }
  },
  {
    path: getPath('ReconciliationBill', baseUrl),
    name: 'ReconciliationBill',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBill" */ '@/views/financialReconciliation/reconciliationBill/index.vue'
      ),
    meta: {
      title: '客户对账单'
    }
  },
  {
    path: getPath('CustomerReconciliationYdz_F9', baseUrl),
    name: 'CustomerReconciliationYdz_F9',
    component: () =>
      import(
        /* webpackChunkName: "CustomerReconciliationYdz_F9" */ '@/views/financialReconciliation/customerReconciliationYdz_F9/index.vue'
      ),
    meta: {
      title: '客户预对账'
    }
  },
  {
    path: getPath('ReconciliationBillYdz', baseUrl),
    name: 'ReconciliationBillYdz',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBillYdz" */ '@/views/financialReconciliation/reconciliationBillYdz/index.vue'
      ),
    meta: {
      title: '客户预对账单'
    }
  },
  {
    path: getPath('ReconciliationBillDtc', baseUrl),
    name: 'ReconciliationBillDtc',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBillDtc" */ '@/views/financialReconciliation/reconciliationBillDtc/index.vue'
      ),
    meta: {
      title: '短途车对账单'
    }
  },
  {
    path: getPath('ReconciliationBillDtc_Detail', baseUrl),
    name: 'ReconciliationBillDtc_Detail',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBillDtc_Detail" */ '@/views/financialReconciliation/reconciliationBillDtc_Detail/index.vue'
      ),
    meta: {
      title: '短途车对账单明细'
    }
  },
  {
    path: getPath('Residentreconciliation', baseUrl),
    name: 'Residentreconciliation',
    component: () =>
      import(
        /* webpackChunkName: "Residentreconciliation" */ '@/views/financialReconciliation/residentreconciliation/index.vue'
      ),
    meta: {
      title: '驻点对账'
    }
  },
  {
    path: getPath('ResidentreconciliationBill', baseUrl),
    name: 'ResidentreconciliationBill',
    component: () =>
      import(
        /* webpackChunkName: "ResidentreconciliationBill" */ '@/views/financialReconciliation/residentreconciliationBill/index.vue'
      ),
    meta: {
      title: '驻点对账对账单'
    }
  },
  {
    path: getPath('ChaufferReconciliation', baseUrl),
    name: 'ChaufferReconciliation',
    component: () =>
      import(
        /* webpackChunkName: "ChaufferReconciliation" */ '@/views/financialReconciliation/chaufferReconciliation/index.vue'
      ),
    meta: {
      title: '制单人结算对账|司机结算对账'
    }
  },
  {
    path: getPath('ChaufferReconciliationBill', baseUrl),
    name: 'ChaufferReconciliationBill',
    component: () =>
      import(
        /* webpackChunkName: "ChaufferReconciliationBill" */ '@/views/financialReconciliation/chaufferReconciliationBill/index.vue'
      ),
    meta: {
      title: '制单人结算对账单|司机结算对账单'
    }
  },
  {
    path: getPath('AgentReconciliation', baseUrl),
    name: 'AgentReconciliation',
    component: () =>
      import(
        /* webpackChunkName: "AgentReconciliation" */ '@/views/financialReconciliation/agentReconciliation/index.vue'
      ),
    meta: {
      title: '代理对账'
    }
  },
  {
    path: getPath('AgentReconciliationBill', baseUrl),
    name: 'AgentReconciliationBill',
    component: () =>
      import(
        /* webpackChunkName: "AgentReconciliationBill" */ '@/views/financialReconciliation/agentReconciliationBill/index.vue'
      ),
    meta: {
      title: '代理对账单'
    }
  },
  {
    path: getPath('AgentReconciliationYdz', baseUrl),
    name: 'AgentReconciliationYdz',
    component: () =>
      import(
        /* webpackChunkName: "AgentReconciliationYdz" */ '@/views/financialReconciliation/agentReconciliationYdz/index.vue'
      ),
    meta: {
      title: '代理预对账'
    }
  },
  {
    path: getPath('AgentReconciliationBillYdz', baseUrl),
    name: 'AgentReconciliationBillYdz',
    component: () =>
      import(
        /* webpackChunkName: "AgentReconciliationBillYdz" */ '@/views/financialReconciliation/agentReconciliationBillYdz/index.vue'
      ),
    meta: {
      title: '代理预对账单'
    }
  },
  {
    path: getPath('CoachReconciliation', baseUrl),
    name: 'CoachReconciliation',
    component: () =>
      import(
        /* webpackChunkName: "CoachReconciliation" */ '@/views/financialReconciliation/coachReconciliation/index.vue'
      ),
    meta: {
      title: '长途车对账'
    }
  },
  {
    path: getPath('ShorthaulReconciliation', baseUrl),
    name: 'ShorthaulReconciliation',
    component: () =>
      import(
        /* webpackChunkName: "ShorthaulReconciliation" */ '@/views/financialReconciliation/shorthaulReconciliation/index.vue'
      ),
    meta: {
      title: '短途车对账'
    }
  },
  {
    path: getPath('Filiale', baseUrl),
    name: 'Filiale',
    component: () =>
      import(
        /* webpackChunkName: "Filiale" */ '@/views/financialReconciliation/filiale/index.vue'
      ),
    meta: {
      title: '分公司对账'
    }
  },
  {
    path: getPath('Company_ReconciliationBill', baseUrl),
    name: 'Company_ReconciliationBill',
    component: () =>
      import(
        /* webpackChunkName: "Company_ReconciliationBill" */ '@/views/financialReconciliation/company_ReconciliationBill/index.vue'
      ),
    meta: {
      title: '分公司对账单'
    }
  },
    {
    path: getPath('Company_ReconciliationBill_ByDispatch', baseUrl),
    name: 'Company_ReconciliationBill_ByDispatch',
    component: () =>
      import(
        /* webpackChunkName: "Company_ReconciliationBill_ByDispatch" */ '@/views/financialReconciliation/company_ReconciliationBill_ByDispatch/index.vue'
      ),
    meta: {
      title: '分公司对账明细单'
    }
  },

  {
    path: getPath('OneSetPrice', baseUrl),
    name: 'OneSetPrice',
    component: () =>
      import(
        /* webpackChunkName: "OneSetPrice" */ '@/views/financialReconciliation/oneSetPrice/index.vue'
      ),
    meta: {
      title: '一口价对账'
    }
  },
  {
    path: getPath('OneSetPriceBill', baseUrl),
    name: 'OneSetPriceBill',
    component: () =>
      import(
        /* webpackChunkName: "OneSetPriceBill" */ '@/views/financialReconciliation/oneSetPriceBill/index.vue'
      ),
    meta: {
      title: '一口价对账单'
    }
  },
  {
    path: getPath('OneSetPriceReconciliationBill_detailed', baseUrl),
    name: 'OneSetPriceReconciliationBill_detailed',
    component: () =>
      import(
        /* webpackChunkName: "OneSetPriceReconciliationBill_detailed" */ '@/views/financialReconciliation/oneSetPriceReconciliationBill_detailed/index.vue'
      ),
    meta: {
      title: '一口价对账明细'
    }
  },
  {
    path: getPath('BranchReconciliation_F9', baseUrl),
    name: 'BranchReconciliation_F9',
    component: () =>
      import(
        /* webpackChunkName: "BranchReconciliation_F9" */ '@/views/financialReconciliation/branchReconciliation_F9/index.vue'
      ),
    meta: {
      title: '代收网点对账'
    }
  },
  {
    path: getPath('BranchReconciliationBill', baseUrl),
    name: 'BranchReconciliationBill',
    component: () =>
      import(
        /* webpackChunkName: "BranchReconciliationBill" */ '@/views/financialReconciliation/branchReconciliationBill/index.vue'
      ),
    meta: {
      title: '代收网点对账单'
    }
  },
  {
    path: getPath('SFReconciliation', baseUrl),
    name: 'SFReconciliation',
    component: () =>
      import(
        /* webpackChunkName: "SFReconciliation" */ '@/views/financialReconciliation/sFReconciliation/index.vue'
      ),
    meta: {
      title: '师傅对账'
    }
  },
  {
    path: getPath('SFReconciliationBill', baseUrl),
    name: 'SFReconciliationBill',
    component: () =>
      import(
        /* webpackChunkName: "SFReconciliationBill" */ '@/views/financialReconciliation/sFReconciliationBill/index.vue'
      ),
    meta: {
      title: '师傅对账单'
    }
  },
  {
    path: getPath('SJReconciliation', baseUrl),
    name: 'SJReconciliation',
    component: () =>
      import(
        /* webpackChunkName: "SJReconciliation" */ '@/views/financialReconciliation/sJReconciliation/index.vue'
      ),
    meta: {
      title: '司机对账单'
    }
  },
  {
    path: getPath('CustomerReconciliation_Detail_F9', baseUrl),
    name: 'CustomerReconciliation_Detail_F9',
    component: () =>
      import(
        /* webpackChunkName: "CustomerReconciliation_Detail_F9" */ '@/views/financialReconciliation/customerReconciliation_Detail_F9/index.vue'
      ),
    meta: {
      title: '保存对账信息'
    }
  },
  {
    path: getPath('CustomerReconciliation_F9_GridDPM', baseUrl),
    name: 'CustomerReconciliation_F9_GridDPM',
    component: () =>
      import(
        /* webpackChunkName: "CustomerReconciliation_F9_GridDPM" */ '@/views/financialReconciliation/customerReconciliation_F9_GridDPM/index.vue'
      ),
    meta: {
      title: '客户对账记录(多品名)'
    }
  },
  {
    path: getPath('ReconciliationBill_DetailList', baseUrl),
    name: 'ReconciliationBill_DetailList',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBill_DetailList" */ '@/views/financialReconciliation/reconciliationBill_DetailList/index.vue'
      ),
    meta: {
      title: '现金|银行存款录入客户对账列表'
    }
  },
  {
    path: getPath('ReconciliationBill_Detailed', baseUrl),
    name: 'ReconciliationBill_Detailed',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBill_Detailed" */ '@/views/financialReconciliation/reconciliationBill_Detailed/index.vue'
      ),
    meta: {
      title: '客户对账单明细'
    }
  },
  {
    path: getPath('ReconciliationBill_Discount', baseUrl),
    name: 'ReconciliationBill_Discount',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBill_Discount" */ '@/views/financialReconciliation/reconciliationBill_Discount/index.vue'
      ),
    meta: {
      title: '客户账单折扣'
    }
  },
  {
    path: getPath('GetInvoiceAddOrEdit', baseUrl),
    name: 'GetInvoiceAddOrEdit',
    component: () =>
      import(
        /* webpackChunkName: "GetInvoiceAddOrEdit" */ '@/views/financialReconciliation/getInvoiceAddOrEdit/index.vue'
      ),
    meta: {
      title: '新增修改查询开票登记'
    }
  },
  {
    path: getPath('ReconciliationBill_DetailedYdz', baseUrl),
    name: 'ReconciliationBill_DetailedYdz',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBill_DetailedYdz" */ '@/views/financialReconciliation/reconciliationBill_DetailedYdz/index.vue'
      ),
    meta: {
      title: '客户预对账单明细'
    }
  },
  {
    path: getPath('ResidentReconciliation_Detail_F9', baseUrl),
    name: 'ResidentReconciliation_Detail_F9',
    component: () =>
      import(
        /* webpackChunkName: "ResidentReconciliation_Detail_F9" */ '@/views/financialReconciliation/residentReconciliation_Detail_F9/index.vue'
      ),
    meta: {
      title: '保存对账信息'
    }
  },
  {
    path: getPath('ResidentsReconciliationBill_Detailed', baseUrl),
    name: 'ResidentsReconciliationBill_Detailed',
    component: () =>
      import(
        /* webpackChunkName: "ResidentsReconciliationBill_Detailed" */ '@/views/financialReconciliation/residentsReconciliationBill_Detailed/index.vue'
      ),
    meta: {
      title: '驻点对账单明细'
    }
  },
  {
    path: getPath('ChaufferReconciliation_Detail_F9', baseUrl),
    name: 'ChaufferReconciliation_Detail_F9',
    component: () =>
      import(
        /* webpackChunkName: "ChaufferReconciliation_Detail_F9" */ '@/views/financialReconciliation/chaufferReconciliation_Detail_F9/index.vue'
      ),
    meta: {
      title: '保存对账信息'
    }
  },
  {
    path: getPath('ChaufferReconciliationBill_Detailed', baseUrl),
    name: 'ChaufferReconciliationBill_Detailed',
    component: () =>
      import(
        /* webpackChunkName: "ChaufferReconciliationBill_Detailed" */ '@/views/financialReconciliation/chaufferReconciliationBill_Detailed/index.vue'
      ),
    meta: {
      title: '结算对账单明细'
    }
  },
  {
    path: getPath('AgentReconciliation_Detail_F9', baseUrl),
    name: 'AgentReconciliation_Detail_F9',
    component: () =>
      import(
        /* webpackChunkName: "AgentReconciliation_Detail_F9" */ '@/views/financialReconciliation/agentReconciliation_Detail_F9/index.vue'
      ),
    meta: {
      title: '保存对账信息'
    }
  },
  {
    path: getPath('AgentReconciliationBill_Detailed', baseUrl),
    name: 'AgentReconciliationBill_Detailed',
    component: () =>
      import(
        /* webpackChunkName: "AgentReconciliationBill_Detailed" */ '@/views/financialReconciliation/agentReconciliationBill_Detailed/index.vue'
      ),
    meta: {
      title: '代理对账单明细'
    }
  },
  {
    path: getPath('AgentReconciliationBill_DetailedYdz', baseUrl),
    name: 'AgentReconciliationBill_DetailedYdz',
    component: () =>
      import(
        /* webpackChunkName: "AgentReconciliationBill_DetailedYdz" */ '@/views/financialReconciliation/agentReconciliationBill_DetailedYdz/index.vue'
      ),
    meta: {
      title: '代理预对账单明细'
    }
  },
  {
    path: getPath('ShorthaulReconciliation_Detail_VEHICLE', baseUrl),
    name: 'ShorthaulReconciliation_Detail_VEHICLE',
    component: () =>
      import(
        /* webpackChunkName: "ShorthaulReconciliation_Detail_VEHICLE" */ '@/views/financialReconciliation/shorthaulReconciliation_Detail_VEHICLE/index.vue'
      ),
    meta: {
      title: '保存对账信息'
    }
  },
  {
    path: getPath('COMPANY_ReconciliationBill_Detailed', baseUrl),
    name: 'COMPANY_ReconciliationBill_Detailed',
    component: () =>
      import(
        /* webpackChunkName: "COMPANY_ReconciliationBill_Detailed" */ '@/views/financialReconciliation/cOMPANY_ReconciliationBill_Detailed/index.vue'
      ),
    meta: {
      title: '分公司对账单明细'
    }
  },
  {
    path: getPath('BranchReconciliation_Detail_F9', baseUrl),
    name: 'BranchReconciliation_Detail_F9',
    component: () =>
      import(
        /* webpackChunkName: "BranchReconciliation_Detail_F9" */ '@/views/financialReconciliation/branchReconciliation_Detail_F9/index.vue'
      ),
    meta: {
      title: '保存对账信息'
    }
  },
  {
    path: getPath('BranchReconciliationBill_Detailed', baseUrl),
    name: 'BranchReconciliationBill_Detailed',
    component: () =>
      import(
        /* webpackChunkName: "BranchReconciliationBill_Detailed" */ '@/views/financialReconciliation/branchReconciliationBill_Detailed/index.vue'
      ),
    meta: {
      title: '代收网点对账单明细'
    }
  },
  {
    path: getPath('SFReconciliation_Detail_F9', baseUrl),
    name: 'SFReconciliation_Detail_F9',
    component: () =>
      import(
        /* webpackChunkName: "SFReconciliation_Detail_F9" */ '@/views/financialReconciliation/sFReconciliation_Detail_F9/index.vue'
      ),
    meta: {
      title: '保存对账信息'
    }
  },
  {
    path: getPath('SFReconciliationBill_Detailed', baseUrl),
    name: 'SFReconciliationBill_Detailed',
    component: () =>
      import(
        /* webpackChunkName: "SFReconciliationBill_Detailed" */ '@/views/financialReconciliation/sFReconciliationBill_Detailed/index.vue'
      ),
    meta: {
      title: '师傅对账单明细'
    }
  },
  {
    path: getPath('ReconciliationBill_DetailedAdd', baseUrl),
    name: 'ReconciliationBill_DetailedAdd',
    component: () =>
      import(
        /* webpackChunkName: "ReconciliationBill_DetailedAdd" */ '@/views/financialReconciliation/reconciliationBill_DetailedAdd/index.vue'
      ),
    meta: {
      title: '添加对账'
    }
  },
  {
    path: getPath('AgentReconciliationBill_DetailedAdd', baseUrl),
    name: 'AgentReconciliationBill_DetailedAdd',
    component: () =>
      import(
        /* webpackChunkName: "AgentReconciliationBill_DetailedAdd" */ '@/views/financialReconciliation/agentReconciliationBill_DetailedAdd/index.vue'
      ),
    meta: {
      title: '添加对账'
    }
  },
  {
    path: getPath('CustomerReconciliation_Detail_F9Ydz', baseUrl),
    name: 'CustomerReconciliation_Detail_F9Ydz',
    component: () =>
      import(
        /* webpackChunkName: "CustomerReconciliation_Detail_F9Ydz" */ '@/views/financialReconciliation/customerReconciliation_Detail_F9Ydz/index.vue'
      ),
    meta: {
      title: '保存预对账信息'
    }
  },
  {
    path: getPath('CustomerReconciliation_F9_GridDPMYdz', baseUrl),
    name: 'CustomerReconciliation_F9_GridDPMYdz',
    component: () =>
      import(
        /* webpackChunkName: "CustomerReconciliation_F9_GridDPMYdz" */ '@/views/financialReconciliation/customerReconciliation_F9_GridDPMYdz/index.vue'
      ),
    meta: {
      title: '客户预对账记录(多品名)'
    }
  },
  {
    path: getPath('Track', baseUrl),
    name: 'FinancialReconciliation_Track',
    component: () => import(/* webpackChunkName: "FinancialReconciliation_Track" */ '@/views/financialReconciliation/track/index.vue'),
    meta: {
      title: '催款记录(多品名)'
    }
  },
  {
    path: getPath('AgentReconciliation_Detail_F9Ydz', baseUrl),
    name: 'AgentReconciliation_Detail_F9Ydz',
    component: () => import(/* webpackChunkName: "AgentReconciliation_Detail_F9Ydz" */ '@/views/financialReconciliation/agentReconciliation_Detail_F9Ydz/index.vue'),
    meta: {
      title: '保存预对账信息'
    }
  }
]
